export default __webpack_public_path__ + "static/media/apps.8dfea2f0.svg";